const KEY = "neec_device_token";
export const getDeviceToken = () => localStorage.getItem(KEY) || "";
export const setDeviceToken = (t) => { if (t) localStorage.setItem(KEY, t); else localStorage.removeItem(KEY); window.dispatchEvent(new Event("neec-device-trusted")); };
// Legacy/manual trust only (localStorage token). Registered POS terminals are recognised server-side via fetchQuickStatus().
export const isTrustedDevice = () => !!getDeviceToken();

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
// Secret-free server view: {quick_login_available, trust_source: pos_register|manual_trust|none, register_name, location_name}
export async function fetchQuickStatus() {
  try {
    const r = await fetch(`${BASE}/auth/quick/status`, { credentials: "include", headers: getDeviceToken() ? { "X-Device-Token": getDeviceToken() } : {} });
    return r.ok ? await r.json() : { quick_login_available: false, trust_source: "none" };
  } catch { return { quick_login_available: false, trust_source: "none" }; }
}
